<template>
    <div class="col-12 nopads">
        <top-bar
            @onSignInClicked="showLogin"
            @onSearchClicked="searchView"/>
        <alert
            :show="alertVisible"
            :message="message"
            :variant="variant"
            @alertShown=alertShown
            @alertDismiss="alertDismiss"
        />
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <transition name="fade">
                    <login v-if="showLogIn"
                           @loginAdmin="showAdminView"
                           @loginUser="showCampaignView"
                           @alert="showAlert"
                           @close="showMain"
                           @resetClose="showNote">
                    </login>
                </transition>
                <div class="col-12 nopads" v-if="!showLogIn">
                    <bread-crumbs :breadcrumbs="this.breadcrumbs" />
                    <b-container class="mb-4 pl-0 pr-0">
                        <b-col lg="12" class="no-gutters">
                            <h3>{{ $t("common.aid_organizations_and_foundations") }}</h3>
                        </b-col>
                    </b-container>
                    <category-organizations-feed v-if="!loading" :organizations="this.organizations" />
                </div>
                <div v-if="loading"
                     id="loader"
                     class="spinner">
                </div>
            </div>
            <footer-area />
        </div>
    </div>

</template>

<script>
import Login from "../components/Login";
import Alert from '../components/Alert'
import {alertMixin} from "../mixins/AlertMixin";
import TopBar from "../components/TopBar";
import FooterArea from "../components/FooterArea";
import BreadCrumbs from "@/components/BreadCrumbs";
import CategoryOrganizationsFeed from "@/components/feed/CategoryOrganizationsFeed";
import FairApi from "@/modules/api";

export default {
    name: "organizations-list-view",
    mixins: [alertMixin],
    components: {CategoryOrganizationsFeed, BreadCrumbs, FooterArea, TopBar, Alert, Login},
    data() {
        return {
            showLogIn: false,
            showSearchField: false,
            category: -1,
            note: false,
            organizations: [],
            breadcrumbs: [
                {
                    text: "breadcrumbs.front_page",
                    translate: true,
                    route: 'main-view',
                    disabled: false,
                    active: false
                },
                {
                    text: "breadcrumbs.organizations",
                    translate: true,
                    route: 'teams-list-view',
                    disabled: true,
                    active: true
                },
            ],
            loading: false
        }
    },

    mounted: function () {
        this.fetchOrganizations()
    },

    methods: {
        searchView : function () {
            this.showLogIn = false
            this.$router.push({name: 'search-view'})
        },

        showLogin: function () {
            this.showLogIn = true
        },

        showMain: function () {
            this.showLogIn = false
        },

        showTeamsListView: function () {
            this.showLogIn = false
            this.$router.push({name: 'teams-list-view'})
        },

        showNote: function () {
            this.note = true
            this.showAlert(this.$t('login.link_send'), "info")
        },

        alertDismiss: function () {
            if (this.note) {
                this.showLogIn = false
                this.note = false
            }
        },

        setCategory(category) {
            this.category = category
        },

        fetchOrganizations: function () {
            this.loading = true
            this.visibleResults = []
            let param = {}
            FairApi.getWithParams(FairApi.organization(), param,
                this.success, this.failed)
        },

        success: function (response) {
            this.results = response.filter(function (item) {
            if (item.stripeId) {
                 return true
             }
            return false
            })
            this.organizations = this.results;
            this.loading = false
        },

        failed: function () {
            this.loading = false
        },

        showAdminView: function () {
          this.showLogIn = false
          this.$router.push({name: 'admin-view'})
        },

        showCampaignView: function () {
          this.showLogIn = false
        },
    }
}
</script>

<style scoped>

</style>